import React from 'react'

export default function Title({text, type}) {
    return (
        <div className="font-bold text-neutral-dark text-lg">
            {text}
        </div>
    )
}
